/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Alert } from 'react-bootstrap';
import BillingoDocumentFlow from '../../../Components/Billingo/BillingoDocumentFlow';

// Optional post-save wizard step: offer to issue a Díjbekérő for invoicing-
// enabled partners. Skippable — not every order gets a Díjbekérő. Mirrors the
// VisitorTrackingOriginStep post-save pattern.
function BillingoWizardStep({
  booking, partner = null, onComplete, onSkip,
}) {
  return (
    <div className="p-2">
      <Alert variant="info">
        <Alert.Heading className="h6">Optional: issue a Díjbekérő</Alert.Heading>
        <p className="mb-0">
          This partner uses per-trip invoicing. You can issue a Díjbekérő (payment request) for
          {' '}
          order
          {' '}
          <strong>{booking.booking_reference || booking._id}</strong>
          {' '}
          now, or skip and create documents later from the order’s Financial tab.
        </p>
      </Alert>

      <BillingoDocumentFlow
        context={{
          mode: 'wizard',
          order: booking,
          partner,
        }}
        onComplete={onComplete}
        onCancel={onSkip}
      />
    </div>
  );
}

export default BillingoWizardStep;
